module.exports = __webpack_public_path__ + "img/bonos.dc736463.svg";